import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogIn, Eye, EyeOff } from 'lucide-react';

export default function OSLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/os/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#FAF9F6' }}>
      <div className="max-w-md w-full">
        <div className="rounded-2xl p-10 border shadow-lg" style={{ backgroundColor: '#FFFFFF', borderColor: '#E8E3D8' }}>
          <div className="text-center mb-10">
            <img
              src="/images/logo-cr-home.png"
              alt="CR Home"
              className="h-14 w-auto mx-auto object-contain mb-5"
            />
            <h2 className="text-3xl font-light tracking-tight" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D2D2D' }}>
              Iniciar Sesión
            </h2>
            <p className="text-sm mt-2" style={{ color: '#C9B8A8' }}>CR HOME OS</p>
          </div>

          {error && (
            <div data-testid="login-error" className="mb-6 p-3 rounded-lg text-sm text-center" style={{ backgroundColor: '#B87B7B20', color: '#B87B7B', border: '1px solid #B87B7B40' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-medium tracking-wider uppercase mb-2" style={{ color: '#C9B8A8' }}>Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-lg text-sm outline-none transition-all duration-200 focus:ring-2"
                style={{ backgroundColor: '#FAF9F6', border: '1px solid #E8E3D8', color: '#2D2D2D', focusRingColor: '#C9A66B' }}
                placeholder="tu@email.com"
              />
            </div>
            <div>
              <label className="block text-xs font-medium tracking-wider uppercase mb-2" style={{ color: '#C9B8A8' }}>Contraseña</label>
              <div className="relative">
                <input
                  data-testid="login-password-input"
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-lg text-sm outline-none transition-all duration-200 pr-10"
                  style={{ backgroundColor: '#FAF9F6', border: '1px solid #E8E3D8', color: '#2D2D2D' }}
                  placeholder="••••••••"
                />
                <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2" style={{ color: '#C9B8A8' }}>
                  {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full py-3.5 rounded-lg text-sm font-medium tracking-wide transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50"
              style={{ backgroundColor: '#2D2D2D', color: '#FAF9F6' }}
              onMouseEnter={e => e.target.style.backgroundColor = '#C9A66B'}
              onMouseLeave={e => e.target.style.backgroundColor = '#2D2D2D'}
            >
              <LogIn size={16} />
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <button onClick={() => navigate('/')} className="text-xs tracking-wide transition-colors" style={{ color: '#C9B8A8' }}
              onMouseEnter={e => e.target.style.color = '#C9A66B'}
              onMouseLeave={e => e.target.style.color = '#C9B8A8'}>
              Volver al sitio principal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
